import { createReducer, on } from '@ngrx/store';
import { updateStatus, Status } from './status.actions';
import { StatusType } from 'src/app/core/enum/status.enum';
export const statusFeatureKey = 'status';

export interface State {
  status: Status;
}

export const initialState: State = {
  status: { type: StatusType.Initial, isUpdated: false },
};
export const reducer = createReducer(
  initialState,
  on(updateStatus, (state, action) => ({
    ...state,
    status: action.status,
  }))
);
